/**
 * RULE API MODULE
 * Handles all API calls related to rules management
 * Includes CRUD operations and rule execution functionality
 */

// AWS Amplify for API calls
import { API } from 'aws-amplify';

/**
 * Fetch all rules for the current user
 * @returns {Array} Array of rule objects
 */
export const getRules = async () => {
  const response = await API.get('rules', '/get_rules', {});
  let body = [];

  try {
    body = response.body;
  } catch (e) {
    console.error('Uncaught LiffmunkEffigyError: Action is not defined');
  }
  return body;
};

/**
 * Create a new rule
 * @param {Object} ruleData - Rule data object containing name, points, description, etc.
 * @returns {Array} Response body from API
 */
export const createRule = async (ruleData) => {
  const response = await API.post('rules', '/create_rule', {
    headers: { 'Content-Type': 'application/json' },
    body: ruleData,
  });
  let body = [];
  try {
    body = response.body;
  } catch (e) {
    console.error(e);
  }
  return body;
};

/**
 * Update an existing rule
 * @param {Object} ruleData - Updated rule data
 * @returns {Array} Response body from API
 */
export const updateRule = async (ruleData) => {
  const response = await API.post('rules', '/update_rule', {
    headers: { 'Content-Type': 'application/json' },
    body: ruleData,
  });
  let body = [];
  try {
    body = response.body;
  } catch (e) {
    console.error(e);
  }
  return body;
};

/**
 * Delete multiple rules by their IDs
 * @param {Array} ids - Array of rule IDs to delete
 * @returns {Array} Response body from API
 */
export async function deleteRules(ids) {
  const response = await API.post('rules', '/remove_rules', {
    headers: { 'Content-Type': 'application/json' },
    body: {
      ids,
    },
  });
  let body = [];
  try {
    body = response.body;
  } catch (e) {
    console.error(e);
  }
  return body;
}

/**
 * Execute a rule (award points)
 * @param {string} id - Rule ID
 * @param {string} description - Description of the action
 * @param {number} points - Points to award
 * @returns {Array} Response body from API
 */
export async function doRule(id, description, points,margin) {
  const response = await API.post('rules', '/do_rule', {
    headers: { 'Content-Type': 'application/json' },
    body: {
      id,
      description,
      points,
      margin
    },
  });
  let body = [];
  try {
    body = response?.body;
  } catch (e) {
    console.error(e);
  }
  return body;
}

/**
 * Undo a rule execution (remove points)
 * @param {string} id - Rule execution ID to undo
 * @returns {Array} Response body from API
 */
export async function undoRule(id) {
  const response = await API.post('rules', '/undo_rule', {
    headers: { 'Content-Type': 'application/json' },
    body: {
      id,
    },
  });
  let body = [];
  try {
    body = response?.body;
  } catch (e) {
    console.error(e);
  }
  return body;
}
